import { createContext, useContext, useState } from "react";
import en from "./en";
import ar from "./ar";

const translations = { en, ar };

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState("en");
  const t = translations[lang];
  const isRTL = lang === "ar";

  function toggleLang() {
    setLang((prev) => (prev === "en" ? "ar" : "en"));
  }

  return (
    <LanguageContext.Provider value={{ lang, t, isRTL, toggleLang }}>
      <div dir={isRTL ? "rtl" : "ltr"} className={isRTL ? "font-arabic" : ""}>
        {children}
      </div>
    </LanguageContext.Provider>
  );
}

export function useLang() {
  return useContext(LanguageContext);
}
